module.exports = __webpack_public_path__ + "Server-Unknown-OfflineDrop.80a5fbb86c97454e5e7c3dcdcc651620.hashedasset.svg";